/**
 * 首屏需要用到的数据
 * common config
 * robot 接口
 */
import { useDispatch } from 'react-redux';

import { isWeb } from '@whelk/const/src/env';
import { setTimbre } from '@whelk/store/slices/audioSlice';
import { ModelType, setIsThinkMode, setRewriteConfig } from '@whelk/store/slices/chatListSlice';
import {
  setChatModelList,
  setCommunityQRCodeURL,
  setDefaultModel,
  setMobileDownloadQRCode,
  setNegativeReviewsList,
  setNotificationLiveModalConfig,
  setQuestionnaireUrl,
  setShowThinkButton,
  setTutorialLinkInfo,
} from '@whelk/store/slices/configSlice';
import { setJumpSpeed } from '@whelk/store/slices/jumpingSlice';
import {
  setAndroidAPKUrl,
  setAndroidQRCodeUrl,
  setIosAppUrl,
  setIosQRCodeUrl,
  setShareConfigState,
} from '@whelk/store/slices/shareSlice';
import { setPreloadUrlConfig, setRegexp } from '@whelk/store/slices/spiderSlice';
import { GetWebCommonConfigMeta } from '@whelk/services/src/type/chat';

const useInitConfig = () => {
  const dispatch = useDispatch();
  // 不需要token
  const onSetWebCommonConfig = (cfg: GetWebCommonConfigMeta) => {
    dispatch(setTimbre(cfg.timbres)); // 音色
    dispatch(setRegexp(cfg.regexp_url)); // 匹配指定文本中的超链接
    dispatch(setAndroidAPKUrl(cfg.apkUrl));
    dispatch(setIosAppUrl(cfg.inspoAppUrl));
    dispatch(setJumpSpeed(cfg.wordSpreadRate));
    // 移动端与pc颜色不一样 所以搞了两套数据 后面改动device_platform在修改这里
    dispatch(setRewriteConfig(isWeb ? cfg.rewriteConfig : cfg.rewriteConfigH5 ?? []));
    dispatch(setPreloadUrlConfig(cfg.preload_url_config)); // 服务端拉取合法的爬取文件信息，用于爬虫预检
    dispatch(setMobileDownloadQRCode(cfg.mobileQRCodeURL));
    dispatch(setCommunityQRCodeURL(cfg.communityQRCodeURL));
    dispatch(setIosQRCodeUrl(cfg.homepageIOSAppStoreQrcode));
    dispatch(setAndroidQRCodeUrl(cfg.homepageAndroidDownloadQrcode));
    dispatch(setNegativeReviewsList(cfg.negative_reviews_list));
    dispatch(
      setShareConfigState({
        discoverSchema: cfg.discoverSchema,
        shareIOSAppStoreQrcode: cfg.shareIOSAppStoreQrcode,
        shareAndroidDownloadQrcode: cfg.shareAndroidDownloadQrcode,
      }),
    );
    dispatch(setTutorialLinkInfo(cfg.tutorial_link));
    dispatch(setChatModelList(cfg.chat_model_list));
    dispatch(setShowThinkButton(cfg.chat_model_config?.showDeepThink ?? false));
    const defaultModel = cfg.chat_model_config?.defaultModel ?? ModelType.NOT_THINK;
    dispatch(setDefaultModel(defaultModel));
    dispatch(setIsThinkMode(defaultModel === ModelType.THINK));
    dispatch(setNotificationLiveModalConfig(cfg.chat_notification_modal_config));
    dispatch(setQuestionnaireUrl(cfg.chat_questionnaire_url));
  };

  return {
    onSetWebCommonConfig,
  };
};

export default useInitConfig;
